export default "__VITE_ASSET__DddDu9Ye__"